import type { ReactNode } from 'react';

import type { Watchlist } from '@/hooks/useWatchlist';

import WatchlistDropdown from '../WatchlistDropdown';
import { Wrapper } from './styled';

export interface Props {
  watchlist: Watchlist;
  onSelectWatchlist: (watchlistId: string) => void;
  children?: ReactNode;
}

const Header = ({ watchlist, children, onSelectWatchlist }: Props) => (
  <Wrapper as="header" justifyContent="space-between" alignItem="center">
    <WatchlistDropdown
      watchlist={watchlist}
      onSelectWatchlist={onSelectWatchlist}
    />
    {children}
  </Wrapper>
);

export default Header;
